(function(){
  'use strict';
  var BH=['2026-12-25','2026-12-28','2027-01-01','2027-03-26','2027-03-29','2027-05-03','2027-05-31','2027-08-30','2027-12-27','2027-12-28','2028-01-03','2028-04-14','2028-04-17','2028-05-01','2028-05-29','2028-08-28','2028-12-25','2028-12-26'];
  var CUTOFF_HOUR=12, MAX_DAYS=90, ATTR='Delivery date', ATTR_ISO='Delivery date (ISO)';
  var DAYS=['Sunday','Monday','Tuesday','Wednesday','Thursday','Friday','Saturday'];
  var MONTHS=['January','February','March','April','May','June','July','August','September','October','November','December'];
  function ukParts(){
    var f=new Intl.DateTimeFormat('en-GB',{timeZone:'Europe/London',year:'numeric',month:'2-digit',day:'2-digit',hour:'2-digit',minute:'2-digit',second:'2-digit',hourCycle:'h23'});
    var p={};f.formatToParts(new Date()).forEach(function(x){p[x.type]=x.value});
    return {y:+p.year,m:+p.month,d:+p.day,h:+p.hour%24,mi:+p.minute,s:+p.second};
  }
  function D(y,m,d){return new Date(Date.UTC(y,m-1,d))}
  function iso(dt){return dt.toISOString().slice(0,10)}
  function addDays(dt,n){var x=new Date(dt.getTime());x.setUTCDate(x.getUTCDate()+n);return x}
  function isWorking(dt){var w=dt.getUTCDay();return w>0&&w<6&&BH.indexOf(iso(dt))<0}
  function nextWorking(dt){var x=addDays(dt,1);while(!isWorking(x))x=addDays(x,1);return x}
  function nice(dt){return DAYS[dt.getUTCDay()]+' '+dt.getUTCDate()+' '+MONTHS[dt.getUTCMonth()]+' '+dt.getUTCFullYear()}
  function short(dt){return DAYS[dt.getUTCDay()]+' '+dt.getUTCDate()+' '+MONTHS[dt.getUTCMonth()]}
  function plan(){
    var p=ukParts(), today=D(p.y,p.m,p.d), dispatch;
    if(isWorking(today)&&p.h<CUTOFF_HOUR){dispatch=today}else{dispatch=nextWorking(today)}
    var delivery=nextWorking(dispatch);
    var nowMs=Date.UTC(p.y,p.m-1,p.d,p.h,p.mi,p.s);
    var cutMs=dispatch.getTime()+CUTOFF_HOUR*3600000;
    return {today:today,dispatch:dispatch,delivery:delivery,left:Math.max(0,cutMs-nowMs)};
  }
  window.MHDelivery={plan:plan,isWorking:isWorking,nice:nice};

  /* ---------- countdown ---------- */
  function fmt(ms){var s=Math.floor(ms/1000),d=Math.floor(s/86400),h=Math.floor(s%86400/3600),m=Math.floor(s%3600/60),sec=s%60;
    if(d>0)return d+'d '+h+'h '+m+'m';return h+'h '+(m<10?'0':'')+m+'m '+(sec<10?'0':'')+sec+'s'}
  function tick(){
    var els=document.querySelectorAll('[data-mh-countdown]');if(!els.length)return;
    var pl=plan(), t=pl.left;
    var when=(iso(pl.delivery)===iso(addDays(pl.today,1)))?'tomorrow, '+short(pl.delivery):short(pl.delivery);
    els.forEach(function(el){
      el.querySelector('[data-cd-time]').textContent=fmt(t);
      el.querySelector('[data-cd-day]').textContent=when;
    });
  }

  /* ---------- delivery date picker ---------- */
  var state={iso:null,min:null,viewY:null,viewM:null,saving:null};
  function parseIso(s){var a=s.split('-');return D(+a[0],+a[1],+a[2])}
  function save(dt){
    state.iso=iso(dt);
    var attrs={};attrs[ATTR]=nice(dt);attrs[ATTR_ISO]=iso(dt);
    state.saving=fetch('/cart/update.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({attributes:attrs})}).catch(function(){});
    renderAll();
    return state.saving;
  }
  function ensure(){
    var pl=plan();state.min=pl.delivery;
    return fetch('/cart.js',{headers:{'Accept':'application/json'}}).then(function(r){return r.json()}).then(function(c){
      var cur=c.attributes&&c.attributes[ATTR_ISO];
      if(cur&&cur>=iso(pl.delivery)&&isWorking(parseIso(cur))){state.iso=cur;renderAll();return}
      if(c.item_count>0)return save(pl.delivery);
      state.iso=iso(pl.delivery);renderAll();
    }).catch(function(){state.iso=iso(pl.delivery);renderAll()});
  }
  var ICON='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><rect x="3" y="5" width="18" height="16" rx="2"/><path d="M3 10h18M8 3v4M16 3v4"/></svg>';
  function widget(){
    var w=document.createElement('div');w.className='mh-dd';w.setAttribute('data-mh-dd','');
    w.innerHTML='<div class="mh-dd__label">'+ICON+'<span data-dd-lab>Delivery date</span></div><button type="button" class="mh-dd__btn" aria-expanded="false"><strong data-dd-val>Next working day</strong><span>Change</span></button><div class="mh-dd__cal" hidden></div><p class="mh-dd__early" data-dd-early hidden></p><small>Next working day delivery on orders placed by 12pm. We don’t deliver on weekends or bank holidays.</small>';
    var btn=w.querySelector('.mh-dd__btn'),cal=w.querySelector('.mh-dd__cal');
    w.addEventListener('click',function(e){if(e.target.closest('[data-dd-use]')){e.preventDefault();e.stopPropagation();save(state.min)}});
    btn.addEventListener('click',function(e){e.preventDefault();e.stopPropagation();var open=cal.hasAttribute('hidden');if(open){var cur=state.iso?parseIso(state.iso):state.min;state.viewY=cur.getUTCFullYear();state.viewM=cur.getUTCMonth();drawCal(cal);cal.removeAttribute('hidden')}else{cal.setAttribute('hidden','')}btn.setAttribute('aria-expanded',open)});
    return w;
  }
  function drawCal(cal){
    var y=state.viewY,m=state.viewM,first=new Date(Date.UTC(y,m,1)),days=new Date(Date.UTC(y,m+1,0)).getUTCDate();
    var min=state.min,max=addDays(min,MAX_DAYS);
    var lead=(first.getUTCDay()+6)%7;
    var html='<div class="mh-dd__head"><button type="button" data-nav="-1" aria-label="Previous month">&#8249;</button><span>'+MONTHS[m]+' '+y+'</span><button type="button" data-nav="1" aria-label="Next month">&#8250;</button></div><div class="mh-dd__grid">';
    ['Mo','Tu','We','Th','Fr','Sa','Su'].forEach(function(d){html+='<div class="mh-dd__dow">'+d+'</div>'});
    for(var i=0;i<lead;i++)html+='<span class="mh-dd__day mh-dd__day--empty"></span>';
    for(var d=1;d<=days;d++){var dt=D(y,m+1,d),k=iso(dt),ok=dt>=min&&dt<=max&&isWorking(dt);
      html+='<button type="button" class="mh-dd__day" data-day="'+k+'" aria-pressed="'+(k===state.iso)+'"'+(ok?'':' disabled')+' aria-label="'+nice(dt)+'">'+d+'</button>'}
    html+='</div><div class="mh-dd__legend">Greyed-out dates are weekends, bank holidays or too soon for delivery.</div>';
    cal.innerHTML=html;
    var prev=cal.querySelector('[data-nav="-1"]'),next=cal.querySelector('[data-nav="1"]');
    prev.disabled=(y<min.getUTCFullYear()||(y===min.getUTCFullYear()&&m<=min.getUTCMonth()));
    next.disabled=(y>max.getUTCFullYear()||(y===max.getUTCFullYear()&&m>=max.getUTCMonth()));
    [prev,next].forEach(function(b){b.addEventListener('click',function(e){e.preventDefault();e.stopPropagation();state.viewM+=+b.getAttribute('data-nav');if(state.viewM<0){state.viewM=11;state.viewY--}if(state.viewM>11){state.viewM=0;state.viewY++}drawCal(cal)})});
    cal.querySelectorAll('[data-day]:not([disabled])').forEach(function(b){b.addEventListener('click',function(e){e.preventDefault();e.stopPropagation();save(parseIso(b.getAttribute('data-day')));cal.setAttribute('hidden','');var w=cal.closest('[data-mh-dd]');if(w)w.querySelector('.mh-dd__btn').setAttribute('aria-expanded','false')})});
  }
  function renderAll(){
    document.querySelectorAll('[data-mh-dd]').forEach(function(w){var v=w.querySelector('[data-dd-val]');if(state.iso)v.textContent=nice(parseIso(state.iso));
      var later=state.iso&&state.min&&state.iso>iso(state.min),lb=w.querySelector('[data-dd-lab]'),ea=w.querySelector('[data-dd-early]');
      if(lb)lb.textContent=later?'Your chosen delivery date':'Delivery date';
      if(ea){if(later){ea.hidden=false;ea.innerHTML='Earliest is '+nice(state.min)+'. <button type="button" data-dd-use>Use earliest</button>'}else ea.hidden=true}
      var cal=w.querySelector('.mh-dd__cal');if(!cal.hasAttribute('hidden'))drawCal(cal)});
  }
  function inject(){
    var btns=document.querySelectorAll('button[name="checkout"],input[name="checkout"],a[href="/checkout"]');
    var added=false;
    btns.forEach(function(b){
      if(b.closest('[data-mh-product]')||b.closest('.mh-atc'))return;
      var host=b.parentElement;if(!host||host.querySelector('[data-mh-dd]')||(host.previousElementSibling&&host.previousElementSibling.hasAttribute&&host.previousElementSibling.hasAttribute('data-mh-dd')))return;
      host.parentElement.insertBefore(widget(),host);added=true;
      if(!b.__mhBound){b.__mhBound=true;b.addEventListener('click',function(){if(!state.iso&&state.min){save(state.min)}},true)}
    });
    if(added){ensure()}
  }
  var t;function schedule(){clearTimeout(t);t=setTimeout(inject,120)}
  function init(){
    tick();setInterval(tick,1000);
    inject();
    new MutationObserver(schedule).observe(document.body,{childList:true,subtree:true});
    document.addEventListener('cart:update',function(){setTimeout(function(){ensure().then(inject)},300)});
    ensure();
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
})();
